import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      english: { translation: {} },
      Portuguese: { translation: {} },
      french: { translation: {} },
    },
    lng: 'english', 
    fallbackLng: 'english',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;



